import { IInitAction } from './init'
import { IPollingTaskData } from './polling'

// Action types
export enum types {
  CREATE_DATACHART__STARTED = 'CREATE_DATACHART__STARTED',
  CREATE_DATACHART__SUCCESS = 'CREATE_DATACHART__SUCCESS',
  CREATE_DATACHART__FAILURE = 'CREATE_DATACHART__FAILURE',
  CREATE_DATACHART_POLLING__SUCCESS = 'CREATE_DATACHART_POLLING__SUCCESS',
  CREATE_DATACHART_POLLING__FAILURE = 'CREATE_DATACHART_POLLING__FAILURE',
  CREATE_DATACHART_SHOW_PROGRESS = 'CREATE_DATACHART_SHOW_PROGRESS',
  CREATE_DATACHART_HIDE_PROGRESS = 'CREATE_DATACHART_HIDE_PROGRESS',
}

export interface ICreateDataChartAction {
  type: types.CREATE_DATACHART__STARTED
  groupId: string
  title: string
  dataStreamURI: string
}

export interface ICreateDataChartSuccessAction {
  type: types.CREATE_DATACHART__SUCCESS
  message: string
}

export interface ICreateDataChartFailureAction {
  type: types.CREATE_DATACHART__FAILURE
  message: string
  correlationId: string
}

export interface ICreateDataChartPollingSuccessAction {
  type: types.CREATE_DATACHART_POLLING__SUCCESS
  data: IPollingTaskData
}

export interface ICreateDataChartPollingFailureAction {
  type: types.CREATE_DATACHART_POLLING__FAILURE
  message: string
  correlationId: string
}

export interface ICreateDataChartShowProgressAction {
  type: types.CREATE_DATACHART_SHOW_PROGRESS
}

export interface ICreateDataChartHideProgressAction {
  type: types.CREATE_DATACHART_HIDE_PROGRESS
}

export type DataChartActionsType =
  | ICreateDataChartAction
  | ICreateDataChartSuccessAction
  | ICreateDataChartFailureAction
  | ICreateDataChartShowProgressAction
  | ICreateDataChartHideProgressAction
  | IInitAction

// Reducer types
export interface IDataChartData {
  isLoading: boolean
  dataStreamURI: string
  title?: string
}
